import { ensureValidDate, ensureValidLocale } from '@opallabs/lambda'
import { gmtInLocale } from './gmtInLocale'
import type { IANATimezoneIdentifier, Options } from './types'

function zoneName(parts: Intl.DateTimeFormatPart[]) {
  return parts.find(({ type }) => type === 'timeZoneName')?.value
}

/**
 * This is a wrapper around `Intl.DateTimeFormat` that returns the localized
 * name of the `timezoneIdentifier` time zone.
 *
 */
export function timeZoneName(
  date: Date,
  timezoneIdentifier: IANATimezoneIdentifier,
  { locale = navigator.language }: Options = {}
) {
  ensureValidDate(date)
  ensureValidLocale(locale)

  const longFormatter = new Intl.DateTimeFormat(locale, {
    timeZone: timezoneIdentifier,
    timeZoneName: 'long',
  })
  const long = zoneName(longFormatter.formatToParts(date))

  const shortFormatter = new Intl.DateTimeFormat(locale, {
    timeZone: timezoneIdentifier,
    timeZoneName: 'short',
  })
  let short = zoneName(shortFormatter.formatToParts(date))
  const gmt = gmtInLocale(locale)
  if (short && gmt && short.startsWith(gmt)) {
    short = undefined
  }

  return {
    long,
    short,
  } as const
}
